module.exports = __webpack_public_path__ + "assets/img/t2.5e1f4f19.png";